import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ReportingDashboard from '../components/reporting/ReportingDashboard';

const ReportingPage: React.FC = () => {
  const { user } = useAuth();

  const hasBusinessAccess =
    user?.isAdmin ||
    user?.businessRoles?.some((r) => r.isBusinessAdmin === true || r.role === 'Admin') === true;

  if (!hasBusinessAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <ReportingDashboard />
    </Container>
  );
};

export default ReportingPage;
